import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'ALIASED-antd';
import { DatePicker } from 'antd';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { useSessionFormState } from '@hooks/useSessionFormState';
import { useSessionOutcome } from '@hooks/useSessionOutcome';
import moment from 'moment';
import { SessionFormItem } from '../../Components/SessionFormItem';

// v1 component
export const AuthorisationFormItem = ({ selfBookLabel }: { selfBookLabel: string }) => {
  const { t } = useTranslation('common');
  const {
    appointment: { appointment_completed: isCompleted, read_only: readonly }
  } = useSessionAppointment();

  const [auth, setAuth] = useSessionFormState('auth');
  const [authDate, setAuthDate] = useSessionFormState('authDate');

  const { defaultAndDisableSelfBook } = useSessionOutcome();

  return (
    <>
      <SessionFormItem name="auth" label={selfBookLabel} data-testid="auth-checkbox">
        <Checkbox
          disabled={isCompleted || readonly || defaultAndDisableSelfBook}
          onChange={(e) => setAuth(e.target.checked)}
          checked={defaultAndDisableSelfBook || auth}
          defaultChecked={defaultAndDisableSelfBook || auth}
          data-testid="allow-patient-F2F-booking"
        />
      </SessionFormItem>
      {(auth || defaultAndDisableSelfBook) && (
        <SessionFormItem
          // name field causes app to crash - field value isn't properly formatted into moment object
          // name="authDate"
          data-testid="auth-start-date"
          label={t('Select start date to activate follow-up')}
        >
          <DatePicker
            disabled={isCompleted || readonly}
            defaultValue={authDate ? moment(authDate) : undefined}
            format="DD/MM/YYYY"
            onChange={(e) => setAuthDate(e || undefined)}
            style={{ width: '40%' }}
          />
        </SessionFormItem>
      )}
    </>
  );
};
